export default __webpack_public_path__ + "static/media/logo.b053d0f8.png";